<template>
  <a-time-picker
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
    v-model="modelList[name]"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { TimePicker } from "ant-design-vue";
export default {
  components: { [TimePicker.name]: TimePicker },
  mixins: [formMixin],
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
